import classNames from "classnames"
import image, { PRODUCT_COVER, PRODUCT_COVER_OLD } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"
import { useVideoPlayer } from "lib/video-player"
import { useAuth } from "lib/auth"
import { useAccesses } from "lib/accesses"

import Image from "components/common/image"

export const Header = ({ product, loading }) => {
	const { c } = useTranslation("common")
	const { showLoginSvod } = useAuth()
	const { hasSubscribed } = useAccesses()
	const { seeFilm } = useVideoPlayer()

	const handleWatchMovie = event => {
		event.preventDefault()
		if (hasSubscribed) {
			seeFilm(product)

			return
		}
		showLoginSvod()
	}

	return (
		<section className="focus full">
			<a
				href="#"
				rel="nofollow noopener"
				title={c("watch-the-movie")}
				className="video-link large more-link"
				onClick={handleWatchMovie}
			>
				<span className={classNames("label", { "skeleton": loading })}>{c("watch-the-movie")}</span>
			</a>
			<div className={classNames("infos", { "skeleton": loading })}>
				<h3 className="film-title">{product.name}</h3>
				<span className="director">{c("by")} {product.director}</span>
				<span className="year">{product.year}</span>
				<span className="country">{product.origin}</span>
				<span className="duration">{product.duration}</span>
			</div>
			<figure className="full">
				<picture>
					<Image
						src={image(product, product.inTreasure ? PRODUCT_COVER_OLD : PRODUCT_COVER)}
						alt={product.name}
						className={loading ? "skeleton" : ""}
					/>
				</picture>
			</figure>
		</section>
	)
}
